import {humanNumber, wordByCount} from '../utils';

function toMetricWeight(weightInGram: number, unit = 'ton'): string {
	const units = [
		{unit: 'gram', factor: 1, suffix: 'г'},
		{unit: 'kgram', factor: 1000, suffix: 'кг'},
		{unit: 'ton', factor: 1_000_000, suffix: 'т'},
	];

	const currentUnitIndex = units.findIndex((u) => u.unit === unit);
	const currentUnit = units[currentUnitIndex];
	let result = [];
	const value = Math.floor(weightInGram * (1 / currentUnit.factor));
	if (value) {
		result.push(`${value} ${currentUnit.suffix}`);
	}
	const diff = weightInGram - value * currentUnit.factor;

	if (diff > 0) {
		const nextUnit = units[currentUnitIndex - 1];
		if (nextUnit) result = [...result, toMetricWeight(diff, nextUnit.unit)];
	}

	return result.join(' ');
}

export function getPounds(weightInLb: number) {
	return humanNumber(weightInLb) + ' ' + wordByCount(weightInLb, ['фунт', 'фунта', 'фунтов']);
}

export function getItemWeight(weightInLb: number) {
	if (weightInLb < 1 / 16) {
		return (
			humanNumber(Math.round(weightInLb * 16 * 16)) +
			' ' +
			wordByCount(Math.round(weightInLb * 16 * 16), ['драхма', 'драхмы', 'драхм'])
		);
	} else if (weightInLb < 1) {
		return (
			humanNumber(Math.round(weightInLb * 16)) +
			' ' +
			wordByCount(Math.round(weightInLb * 16), ['унция', 'унции', 'унций'])
		);
	} else if (weightInLb < 2000) {
		return getPounds(weightInLb);
	}
	const tons = Math.floor(weightInLb / 2000);
	const lbs = weightInLb - 2000 * tons;
	let result =
		humanNumber(tons) + ' ' + wordByCount(tons, ['американская тонна', 'американские тонны', 'американских тонн']);
	if (lbs > 0) result += ' ' + humanNumber(lbs) + ' ' + wordByCount(lbs, ['фунт', 'фунта', 'фунтов']);

	return `${result} (${toMetricWeight(weightInLb * 453.59237)})`;
}
